export { default as configureStore } from './configureStore'
